"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TRANSCODING_STATUSES;
(function (TRANSCODING_STATUSES) {
    TRANSCODING_STATUSES["IN_QUEUE"] = "IN-QUEUE";
    TRANSCODING_STATUSES["PENDING"] = "PENDING";
    TRANSCODING_STATUSES["INPROGRESS"] = "INPROGRESS";
    TRANSCODING_STATUSES["PREVIEW_READY"] = "PREVIEW_READY";
    TRANSCODING_STATUSES["READY"] = "READY";
    TRANSCODING_STATUSES["FAILED"] = "FAILED";
    TRANSCODING_STATUSES["NONE"] = "NONE";
})(TRANSCODING_STATUSES = exports.TRANSCODING_STATUSES || (exports.TRANSCODING_STATUSES = {}));
var TRANSCODING_STATUSES_V2;
(function (TRANSCODING_STATUSES_V2) {
    TRANSCODING_STATUSES_V2["IN_QUEUE"] = "IN-QUEUE";
    TRANSCODING_STATUSES_V2["PENDING"] = "PENDING";
    TRANSCODING_STATUSES_V2["INPROGRESS"] = "INPROGRESS";
    TRANSCODING_STATUSES_V2["PREVIEW_READY"] = "PREVIEW_READY";
    TRANSCODING_STATUSES_V2["READY"] = "READY";
    TRANSCODING_STATUSES_V2["FAILED"] = "FAILED";
    TRANSCODING_STATUSES_V2["INIT"] = "INIT";
})(TRANSCODING_STATUSES_V2 = exports.TRANSCODING_STATUSES_V2 || (exports.TRANSCODING_STATUSES_V2 = {}));
//# sourceMappingURL=transcoding-statuses.js.map